import React from 'react';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import NotificationBell from './NotificationBell';

interface HeaderProps {
  toggleSidebar: () => void;
  sidebarOpen: boolean;
}

const Header: React.FC<HeaderProps> = ({ toggleSidebar, sidebarOpen }) => {
  const { user } = useAuth();
  
  return (
    <header className="bg-white h-16 border-b border-gray-200 flex items-center justify-between px-4 lg:px-6">
      <div className="flex items-center">
        <button 
          onClick={toggleSidebar} 
          className="block lg:hidden mr-4 text-gray-500 hover:text-gray-700"
        >
          {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
        <h1 className="text-xl font-semibold text-gray-800 hidden sm:block">
          {window.location.pathname === '/dashboard' 
            ? 'Dashboard' 
            : window.location.pathname.charAt(1).toUpperCase() + window.location.pathname.slice(2)}
        </h1>
      </div>
      
      <div className="flex items-center">
        {/* Only show notifications for admin users */}
        {user?.role === 'admin' && (
          <NotificationBell className="mr-4" />
        )}
        
        <div className="mr-3 text-right hidden sm:block">
          <div className="text-sm font-medium">{user?.name ? user.name.charAt(0).toUpperCase() + user.name.slice(1) : ''}</div>
          <div className="text-xs text-gray-400">{user?.email}</div>
        </div>
        <div className="h-10 w-10 rounded-full bg-pink-500 flex items-center justify-center text-white font-medium">
          {user?.role === 'admin' ? 'A' : 'T'}
        </div>
      </div>
    </header>
  );
};

export default Header;